import type { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { getErrorDetail } from "components/utility/utils";
import { parseRawTemplateResponse } from "notes-and-forms-v2/util/convertTemplateToV2";
import { fetchOrchidAPI } from "utils/api";

export default async function querySecureData<T extends TNotesType>({
  type,
  id,
  schemaRevision,
  onBehalfOf,
}: {
  type: T;
  id: string | number;
  schemaRevision?: string | number | null;
  onBehalfOf?: string;
}): Promise<T extends "note" ? NoteData : OrchidFormData> {
  if (!type) {
    throw new Error("need note or form type");
  }

  const queryParams = new URLSearchParams();
  queryParams.append(`${type}_data_id`, id.toString());
  if (schemaRevision !== undefined && schemaRevision !== null) {
    queryParams.append(`${type}_schema_revision`, schemaRevision.toString());
  }
  if (onBehalfOf) {
    queryParams.append("on_behalf_of", onBehalfOf);
  }

  const res = await fetchOrchidAPI(
    `/api/notes_secure_data/v1/${type}s/data/${type}_data?${queryParams.toString()}`,
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  if (type === "note") {
    const raw = await res.json();

    return parseRawTemplateResponse(type, raw);
  }

  return res.json();
}
